<template>
    <div class="flex flex-col justify-center items-center">
        <h1 class="text-4xl text-gray-900">{{ title }}</h1>
        <div class="text-xl text-gray-700 mt-1">{{ description }}</div>
        <inertia-link :href="route('shop.landing')" class="btn-gray mt-8">
          Back to Home
        </inertia-link>
    </div>
</template>

<script>
    import Layout from '@/Shared/Layout'
    export default {
        metaInfo() {
          return {
            title: this.status,
            meta: [ 
              { name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive' },
              { name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive' }
            ]
          }
        },
        layout: Layout,
        components: {
            Layout
        },
        props: {
          status: Number,
        },
        computed: {
        title() {
          return {
            503: '503: Service Unavailable',
            500: '500: Server Error',
            404: '404: Page Not Found',
            403: '403: Forbidden',
          }[this.status]
        },
        description() {
          return {
            503: 'Sorry, we are doing some maintenance. Please check back soon.',
            500: 'Whoops, something went wrong on our servers.',
            404: 'Sorry, the page you are looking for could not be found.',
            403: 'Sorry, you are forbidden from accessing this page.',
          }[this.status]
        },
      },
    }
</script>